import Linkedin from "../assests/images/Logos/linkedin.svg"
import Github from "../assests/images/Logos/github.svg"
import Mail from "../assests/images/Logos/mail.svg"
import HR from "../assests/images/Logos/HR.svg"
import H from "../assests/images/Logos/H.svg"
import R from "../assests/images/Logos/R.svg"

export const Logos = {
    Linkedin,
    Github,
    Mail,
    HR,
    H,
    R,
}